"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _tooltip = require("../tooltip");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const PieTooltip = ({
  data,
  color,
  tooltipFormat,
  tooltip,
  theme
}) => {
  return _react.default.createElement(_tooltip.BasicTooltip, {
    id: data.label,
    value: data.value,
    enableChip: true,
    color: color,
    theme: theme,
    format: tooltipFormat,
    renderContent: typeof tooltip === 'function' ? tooltip.bind(null, _extends({
      color
    }, data)) : null
  });
};

PieTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    value: _propTypes.default.number.isRequired
  }).isRequired,
  color: _propTypes.default.string.isRequired,
  tooltipFormat: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  tooltip: _propTypes.default.func,
  theme: _propTypes.default.shape({
    tooltip: _propTypes.default.shape({}).isRequired
  }).isRequired
} : {};

var _default = (0, _pure.default)(PieTooltip);

exports.default = _default;
module.exports = exports.default;